<script setup lang="ts">
import type { VTranslationNoticesProps } from "./VLanguageSwitch.types";
import VButton from "../Button/VButton.vue";
import VIcon from "../Icon/VIcon.vue";
import VSwitch from "../Switch/VSwitch.vue";

defineOptions({
  name: "VTranslationNotices",
});

const {
  showTranslateNotice = false,
  translateNoticeText = "",
  translateAutomaticallyLabel = "",
  showOutdatedNotice = false,
  outdatedNoticeText = "",
  refreshLabel = "",
  refreshing = false,
  disabled = false,
} = defineProps<VTranslationNoticesProps>();

const emit = defineEmits<{
  refresh: []
}>();

const translateAutomatically = defineModel<boolean>("translateAutomatically", { default: false });
</script>

<template>
  <div
    v-if="showTranslateNotice"
    class="flex flex-wrap items-center justify-between gap-x-3 gap-y-1.5"
    data-test="translate-notice"
  >
    <span class="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-300">
      <VIcon name="info" class="text-primary-600 dark:text-primary-400" />
      {{ translateNoticeText }}
    </span>
    <VSwitch
      v-model="translateAutomatically"
      size="small"
      label-position="left"
      label-class="mb-0! text-xs text-gray-600 dark:text-gray-300"
      :disabled="disabled"
      :label="translateAutomaticallyLabel"
    />
  </div>
  <div
    v-if="showOutdatedNotice"
    class="flex flex-wrap items-center justify-between gap-x-3 gap-y-1.5"
    data-test="outdated-notice"
  >
    <span class="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-300">
      <VIcon name="triangle-alert" class="text-warning-600 dark:text-warning-400" />
      {{ outdatedNoticeText }}
    </span>
    <VButton
      size="small"
      variant="gray"
      rounded
      :disabled="disabled"
      icon-left="refresh-cw"
      :loading="refreshing"
      data-test="refresh"
      @click="emit('refresh')"
    >
      {{ refreshLabel }}
    </VButton>
  </div>
</template>
